export default "__VITE_ASSET__hXEZ0ZHO__"